import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";

const Reports = () => {

    const routes = all_routes;
    const roleId = localStorage.getItem('RoleId');

    const [activeTab, setActiveTab] = useState("");

    let tabData = [
        {
            name: "Institutes Status Report",
            content: ""
        },
        {
            name: "Students Report",
            content: ""
        },
        {
            name: "Attendance Report",
            content: ""
        },
        {
            name: "Assessment Report",
            content: ""
        },

        {
            name: "Institutes Filtered by Sport",
            content: ""
        },
    ];
    if (roleId == 1) {
        tabData = tabData.concat([
            {
                name: "Institutes Report",
                content: ""
            },
            {
                name: "Internal Users Report",
                content: ""
            },
            {
                name: "BMI Report",
                content: ""
            },
            {
                name: "Coach Performance Report",
                content: ""
            },
            {
                name: "Coach Attendance Report",
                content: ""
            },
        ]);
    }
    return (
        <>
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items-center">
                                <h3 className="text-center mb-40">Reports</h3>
                            </div>
                            {/* <div className="row d-flex align-items-center">
                                <div className="col-xl-12 col-lg-12 col-sm-12 col-md-12">
                                    <div className="coach-court-list">
                                        <ul className="nav">
                                            {tabData.map((tab, i) => (
                                                <li key={i}>
                                                    <Link to="#"
                                                        className={tab.name === activeTab ? 'active' : ''}
                                                        onClick={() => setActiveTab(tab.name)}>
                                                        {tab.name}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    {tabData.map((tab, i) => (
                                        <div key={i} style={{ display: tab.name === activeTab ? 'block' : 'none' }}>
                                            {tab.content}
                                        </div>
                                    ))}
                                </div>
                            </div> */}

                            <div className="row">
                                {(roleId != '7') ? (
                                    <div className="col-md-4 text-center mb-4">
                                        <Link to={routes.institutestatus} className="icon-link">
                                            <div className="icon-container">
                                                <i className="fa fa-university fa-5x me-1"></i>
                                                <h6>Institutes Status Report</h6>
                                            </div>
                                        </Link>
                                    </div>
                                ) : null}
                                {(roleId == '1' || roleId == '3') ? (
                                    <>
                                        <div className="col-md-4 text-center mb-4">
                                            <Link to={routes.institutionreport} className="icon-link">
                                                <div className="icon-container">
                                                    <i className="fa fa-chart-pie fa-5x me-1"></i>
                                                    <h6>Institutes Report</h6>
                                                </div>
                                            </Link>
                                        </div>

                                        <div className="col-md-4 text-center mb-4">
                                            <Link to={routes.internaluserreport} className="icon-link">
                                                <div className="icon-container">
                                                    <i className="fa fa-street-view fa-5x me-1"></i>
                                                    <h6>Internal Users Report</h6>
                                                </div>
                                            </Link>
                                        </div>
                                    </>
                                ) : null}
                                <div className="col-md-4 text-center mb-4">
                                    <Link to={routes.studentreport} className="icon-link">
                                        <div className="icon-container">
                                            <i className="fa fa-user-graduate fa-5x me-1"></i>
                                            <h6>Students Report</h6>
                                        </div>
                                    </Link>
                                </div>
                                <div className="col-md-4 text-center mb-4">
                                    <Link to={routes.attendancereport} className="icon-link">
                                        <div className="icon-container">
                                            <i className="fa fa-user-clock fa-5x me-1"></i>
                                            <h6>Attendance Report</h6>
                                        </div>
                                    </Link>
                                </div>
                                <div className="col-md-4 text-center mb-4">
                                    <Link to={routes.assessmentreport} className="icon-link">
                                        <div className="icon-container">
                                            <i className="fa fa-bar-chart fa-5x me-1"></i>
                                            <h6>Assessments Report</h6>
                                        </div>
                                    </Link>
                                </div>
                                {(roleId == '1' || roleId == '3') && (
                                    <>
                                        <div className="col-md-4 text-center mb-4">
                                            <Link to={routes.bmireport} className="icon-link">
                                                <div className="icon-container">
                                                    <i className="fa fa-ruler-combined fa-5x me-1"></i>
                                                    <h6>BMI Report</h6>
                                                </div>
                                            </Link>
                                        </div>
                                        <div className="col-md-4 text-center mb-4">
                                            <Link to={routes.coachperformancereport} className="icon-link">
                                                <div className="icon-container">
                                                    <i className="fa fa-chart-area fa-5x me-1"></i>
                                                    <h6>Coach Performance Report</h6>
                                                </div>
                                            </Link>
                                        </div>
                                    </>
                                )}
                                {(roleId == '1' || roleId == '3' || roleId == '7') && (
                                    <>
                                        <div className="col-md-4 text-center mb-4">
                                            <Link to={routes.coachattendancereport} className="icon-link">
                                                <div className="icon-container">
                                                    <i className="fa fa-user-check fa-5x me-1"></i>
                                                    <h6>Coach Attendance Report</h6>
                                                </div>
                                            </Link>
                                        </div>
                                    </>
                                )}
                                {(roleId != '3' && roleId != '7') && (
                                    <>
                                        <div className="col-md-4 text-center mb-4">
                                            <Link to={routes.institutesfilteredbysport} className="icon-link">
                                                <div className="icon-container">
                                                    <i className="fa fa-futbol fa-5x me-1"></i>
                                                    <h6>Institutes Filtered by Sport</h6>
                                                </div>
                                            </Link>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Reports;